import { useEffect, useState } from "react";

import { fetchApi } from "../../Network/NetworkService";
import { ButtonToolbar, MenuItem, Modal, Panel, SplitButton } from "react-bootstrap";
import { notif } from "../Ui/Notification";

export default function LTVClientOld() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(2021)

  useEffect(() => {
    setLoading(true)
    fetchApi("/users/analytics/ltv", {
        method: 'POST',
        body: JSON.stringify({
            year
        })
    })
      .then((json) => {
        setData(json.results);
        setLoading(false);
      })
      .catch((err) => {
        notif.addNotification(
            'Erreur',
            err,
            'warning'
        )
        setLoading(false);
      });
  }, [year]);

  

  return (
    <Panel>
        <Modal
            show={loading}
            backdrop="static"
            keyboard={false}
            size="lg"
            className="modal-spinner"
        >
            <span className="loader" />
            {loading && <p>Récupération des données en cours...</p>}
        </Modal>
        <Panel.Heading>
            <h6>            
                LTV des récurrents
            </h6>

        </Panel.Heading>
        <Panel.Body>
            <div style={{ paddingBottom: 10 }}>
                <ButtonToolbar>
                    <SplitButton
                        id="option-list"
                        rootCloseEvent="mousedown"
                        title={`Année ${year}`}
                    >   
                        {
                            Array.from(
                                { length: new Date().getFullYear() - 2021 + 1 }, // +1 to include the current year
                                (_, index) => 2021 + index
                              ).map((v) => (
                                <MenuItem
                                    eventKey={v}
                                    active={v === year}
                                    onSelect={v === year ? undefined : () => { setYear(v) }}
                                    key={v}
                                >
                                    {v}
                                </MenuItem>
                            ))
                        }
                    </SplitButton>
                </ButtonToolbar>
            </div>
            <div className="table-responsive">
                <table className="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: 90 }}>Mois</th>
                            <th>Nb de nouveaux clients</th>
                            <th>Nb encore actifs</th>
                            <th>Nb churnés</th>
                            <th>Consultations totales</th>
                            <th>CA total (€)</th>
                            <th>ARPU (€)</th>
                            <th>Churn (%)</th>
                            <th>Durée de vie estimée</th>
                            <th>LTV brute (€)</th>
                            <th>LTV nette (€)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((v) => (
                            <tr key={v.month}>
                                <td>{v.month}</td>
                                <td>{v.newClient}</td>
                                <td>{v.activeClient}</td>
                                <td>{v.nbChurn}</td>
                                <td>{v.nbTotalTlc}</td>
                                <td>{v.caTotal}</td>
                                <td>{v.arpu}</td>
                                <td>{v.churnRate}</td>
                                <td>{v.lifetime}</td>
                                <td>{v.ltvBrute}</td>
                                <td>{v.ltvNet}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </Panel.Body>
    </Panel>
  );
}